import { 
  OPEN_MASS_ITEM_LOCATION_MODAL,
  CLOSE_MASS_ITEM_LOCATION_MODAL,
  SHOW_MASS_ITEM_MESSAGE_MODAL,
  PROCESSING_MASS_CREATE_ITEMS,
  SET_TARGET_LOCATION
} from './MassItemLocationModalConstants';

const INITITAL_STATE = {
  isModalActive: false,
  modalHeader: '',
  targetLocationId: null,
  targetCurrencyId: null,
  isProcessing: false,
  showMessageModal: false,
  noOfItems: 0
};

export function MassItemLocationModalReducer(state = INITITAL_STATE, action) {
  switch (action.type) {
    case OPEN_MASS_ITEM_LOCATION_MODAL: {
      return {
        ...state,
        isModalActive: true
      };
    }

    case CLOSE_MASS_ITEM_LOCATION_MODAL: {
      return {
        ...state,
        isModalActive: false
      };
    }

    case SHOW_MASS_ITEM_MESSAGE_MODAL: {
      return {
        ...state,
        showMessageModal: action.showMessageModal
      }
    }

    case PROCESSING_MASS_CREATE_ITEMS: {
      return {
        ...state,
        isProcessing: action.isProcessing,
        noOfItems: action.noOfItems
      }
    }

    case SET_TARGET_LOCATION: {
      return {
        ...state,
        targetLocationId: action.targetLocationId,
        targetCurrencyId: action.targetCurrencyId
      };
    }

    default:
      return state;
  }
}
